import { PickedLocation } from "@/models/AdditionalDataTypes";

export class AddressService {
  static async getAddress(coords: number[], apiKey?: string): Promise<PickedLocation | null> {

    if (coords.length > 1) {
      const googleApi = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${coords[0]},${coords[1]}&key=${apiKey}`
      const gData = await (await fetch(googleApi)).json()

      const country = gData.results[0]?.address_components?.find(adr => adr.types.includes('country'))?.long_name ?? '';
      const city = gData.results[0]?.address_components?.find(adr => adr.types.includes('locality'))?.long_name ?? '';
      const street = gData.results[0]?.address_components?.find(adr => adr.types.includes('route'))?.long_name ?? '';
      const streetNumber = gData.results[0]?.address_components?.find(adr => adr.types.includes('street_number'))?.long_name ?? '';
  
      const res = { country, city, street, streetNumber }
      return res
    }

    return null
  }
}
